/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { connect } from "react-redux";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import { Container, Box, Grid } from "@material-ui/core";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { DocumentCategoryForm } from "./DocumentCategoryForm";
import { DocumentCategoryListing } from "./DocumentCategoryListing";

const DocumentCategoryView = (props) => {
  let api = AppAPIService.getInstance();
  const [editingRecord, setEditingRecord] = useState(null);

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleSetEditingRecord = (record) => {
    document.getElementById("scrollTop").scrollIntoView({ behavior: "smooth" });
    setEditingRecord(record);
  };

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        minHeight: "70vh",
      }}
      maxWidth="xl"
    >
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{
            boxShadow: "none",
            width: "100%",
          }}
        >
          <LabelWithBackLine>Dados do Documento</LabelWithBackLine>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: 0,
              marginTop: "35px",
              width: "100%",
              marginBottom: "35px",
            }}
            boxShadow="none"
          >
            <DocumentCategoryForm
              editingRecord={editingRecord}
              handleSetEditingRecord={setEditingRecord}
            />
          </Box>
          <LabelWithBackLine>Documentos Parametrizados</LabelWithBackLine>
          <Container
            maxWidth="xl"
            style={{
              boxShadow: "none",
              padding: 0,
              marginTop: "20px",
            }}
          >
            <DocumentCategoryListing
              setEditingRecord={handleSetEditingRecord}
            />
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(DocumentCategoryView);
